import { Swiper, SwiperSlide } from 'swiper/react'
import { Container, TituloSecao, Video, VideoCard } from './styles'

declare let require: {
  context: (
    directory: string,
    useSubdirectories?: boolean,
    regExp?: RegExp
  ) => {
    keys: () => string[];
    (id: string): string
  }
}
const contextoVideos = require.context('../../Assets/Videos', false, /\.mp4$/)

const videosImportados: { [key: string]: string } = {}

contextoVideos.keys().forEach((item: string) => {
  // Remove o './' e a extensão '.mp4' para criar uma chave limpa
  const chaveLimpa = item.replace('./', '').replace('.mp4', '')
  videosImportados[chaveLimpa] = contextoVideos(item)
})
console.log('Vídeos localizados:', Object.keys(videosImportados))

const videosExemplo = [
  {
    id: 1,
    url: videosImportados['Cantarei teu amor - Eli Soares'],
    titulo: 'Cantarei teu amor'
  },
  {
    id: 2,
    url: videosImportados['Deixar a lágrima rolar - Bruna Karla'],
    titulo: 'Deixar a lágrima rolar'
  },
  {
    id: 3,
    url: videosImportados['Novo dia - GetWorship'],
    titulo: 'Novo dia'
  },
  {
    id: 4,
    url: videosImportados['Sublime - FHOP'],
    titulo: 'Sublime'
  },
  {
    id: 5,
    url: videosImportados["Sweet child O'mine - Guns N Roses"],
    titulo: "Sweet child O'mine"
  }
]

const Videos = () => {
  return (
    <Container>
      <TituloSecao>Na Prática</TituloSecao>
      <Swiper
        style={{ height: '900px' }}
        touchMoveStopPropagation={true} // Impede que o movimento do dedo passe para o navegador
        edgeSwipeDetection={true} // Ajuda a distinguir o deslize interno do deslize de borda
        observeSlideChildren={true}
        observeParents={true}
        slidesPerView={1}
        spaceBetween={20}
        centeredSlides={true}
        breakpoints={{
          768: { slidesPerView: 1.5, spaceBetween: 0 } // Mostra 3 no desktop para manter o estilo
        }}
        effect={'coverflow'}
        loop={true}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2, // Ajusta o quanto o centro se destaca
          slideShadows: false
        }}
      >
        {videosExemplo.map((video) => (
          <SwiperSlide key={video.id}>
            <VideoCard>
              <Video
                controls
                preload="metadata"
                style={{ width: '100%', borderRadius: '12px' }}
              >
                <source src={video.url} type="video/mp4" />
                Seu navegador não suporta vídeos.
              </Video>
              <h4>{video.titulo}</h4>
            </VideoCard>
          </SwiperSlide>
        ))}
      </Swiper>
    </Container>
  )
}

export default Videos
